export class CatCollectAmountRangeModel {
    public collectAmountRangeId?:number;
    public employeeJobId?:number;
    public collectAmountGroupId?:number;
    public description?:string;
    public minCollect?:number;
    public maxCollect?:number;
    public commission?:number;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}